import {Injectable} from '@angular/core';
import {ImageAnnotationElement, TupleOfstringAndstring} from '../api/api-client';

@Injectable({
  providedIn: 'root'
})
export class PictureAnnotationWidgetService {

  legendEntries: TupleOfstringAndstring[]=[];
  imageAnnotations:ImageAnnotationElement[]=[];

  imageAnnotationUndoHistory:ImageAnnotationElement[]=[];

  undoAnnotation(){
    if(this.imageAnnotations.length>0){
      this.imageAnnotationUndoHistory.push(this.imageAnnotations.pop() as ImageAnnotationElement);
    }
  }
  redoAnnotation(){
    if(this.imageAnnotationUndoHistory.length>0){
      this.imageAnnotations.push(this.imageAnnotationUndoHistory.pop() as ImageAnnotationElement);
    }
  }


}
